import { Vendors as VendorsPage } from "../BillsAndVendors/Vendors";

export const Vendors = () => {
  return (
    <>
      <title>Vendors | Inkle</title>
      <VendorsPage />
    </>
  );
};
